// Client-side responsible-gambling tools (no backend endpoint exists for these).
const LIMITS_KEY = "rrc_limits";
const COOLOFF_KEY = "rrc_cooloff_until";
const SPEND_KEY = "rrc_spend_log";

export const getLimits = () => {
  try { return JSON.parse(localStorage.getItem(LIMITS_KEY)) || { daily: 0, weekly: 0, monthly: 0 }; }
  catch { return { daily: 0, weekly: 0, monthly: 0 }; }
};
export const saveLimits = (l) => localStorage.setItem(LIMITS_KEY, JSON.stringify(l));

export const getCooloffUntil = () => {
  const v = localStorage.getItem(COOLOFF_KEY);
  return v ? Number(v) : 0;
};
export const isCoolingOff = () => getCooloffUntil() > Date.now();
export const setCooloff = (ms) => localStorage.setItem(COOLOFF_KEY, String(Date.now() + ms));

const getSpendLog = () => {
  try { return JSON.parse(localStorage.getItem(SPEND_KEY)) || []; }
  catch { return []; }
};
export const recordSpend = (amount) => {
  const log = getSpendLog();
  log.push({ amount: Number(amount), ts: Date.now() });
  localStorage.setItem(SPEND_KEY, JSON.stringify(log.slice(-500)));
};
const sumSince = (since) => getSpendLog().filter((e) => e.ts >= since).reduce((a, b) => a + b.amount, 0);

// Returns null if OK, or a string error if blocked.
export const checkSpend = (amount) => {
  if (isCoolingOff()) {
    const until = new Date(getCooloffUntil()).toLocaleString("en-GB");
    return `You are in a self-exclusion cool-off period until ${until}.`;
  }
  const l = getLimits();
  const now = Date.now();
  const day = sumSince(now - 86400000) + Number(amount);
  const week = sumSince(now - 7 * 86400000) + Number(amount);
  const month = sumSince(now - 30 * 86400000) + Number(amount);
  if (l.daily > 0 && day > l.daily) return `This purchase exceeds your daily spend limit of £${l.daily}.`;
  if (l.weekly > 0 && week > l.weekly) return `This purchase exceeds your weekly spend limit of £${l.weekly}.`;
  if (l.monthly > 0 && month > l.monthly) return `This purchase exceeds your monthly spend limit of £${l.monthly}.`;
  return null;
};

export const COOLOFF_OPTIONS = [
  { label: "24 hours", ms: 24 * 3600000 },
  { label: "1 week", ms: 7 * 86400000 },
  { label: "1 month", ms: 30 * 86400000 },
  { label: "6 weeks", ms: 42 * 86400000 },
  { label: "6 months", ms: 182 * 86400000 },
];
